import { AxiosResponse } from "axios";
import { SET_ACTIVITY_LOGS, SET_ACTIVITY_LOG, SET_ERRORMSG } from "@/store/mutation-types";
import {
  CLEAR_ACTIVITY_LOG_ISLOADING,
  DELETE_ACTIVITY_LOG,
  EDIT_ACTIVITY_LOG,
  GET_ACTIVITY_LOGS,
  REGISTER_ACTIVITY_LOG,
} from "@/store/action-types";
import { StateObject } from "@/dtos/State.dto";
import ActivityLog from "@/services/activity-log";
import { Module } from "vuex";
import { EditActivityLog, RegisterActivityLog, GetActivityLog } from "@/dtos/ActivityLog.dto";

const activityLog: Module<any, {}> = {
  state: {
    activityLog: {
      data: null,
      isLoading: false,
    },
    activityLogs: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    activityLog: (state: { activityLog: any }) => state.activityLog,
    activityLogs: (state: { activityLogs: any }) => state.activityLogs,
  },
  mutations: {
    [SET_ACTIVITY_LOG]: (
      state: { activityLog: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.activityLog.data = payload.data;
      state.activityLog.isLoading = payload.isLoading;
    },
    [SET_ACTIVITY_LOGS]: (
      state: { activityLogs: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.activityLogs.data = payload.data;
      state.activityLogs.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_ACTIVITY_LOG]: async ({ commit }: any, payload: any) => {
      commit(SET_ACTIVITY_LOG, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await ActivityLog.registerActivityLog(
          payload as RegisterActivityLog
        );

        if (result) {
          if (result.data.status) {
            commit(SET_ACTIVITY_LOG, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_ACTIVITY_LOG, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_ACTIVITY_LOG, { isLoading: false });
          return false;
        }
      } catch (error) {
        commit(SET_ACTIVITY_LOG, { isLoading: false });
        commit(SET_ERRORMSG, "Failed to register activity log. Please try again.");
        return false;
      }
    },
    [GET_ACTIVITY_LOGS]: async ({ commit }: any, payload: any) => {
      commit(SET_ACTIVITY_LOGS, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await ActivityLog.getActivityLogs(payload as GetActivityLog);

        if (result) {
          if (result.data.status) {
            commit(SET_ACTIVITY_LOGS, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_ACTIVITY_LOGS, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_ACTIVITY_LOGS, { isLoading: false });
          return false;
        }
      } catch (error) {
        commit(SET_ACTIVITY_LOGS, { isLoading: false });
        commit(SET_ERRORMSG, "Failed to get activity logs. Please try again.");
        return false;
      }
    },
    [EDIT_ACTIVITY_LOG]: async ({ commit }: any, payload: any) => {
      commit(SET_ACTIVITY_LOG, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await ActivityLog.editActivityLog(payload as EditActivityLog);

        if (result) {
          if (result.data.status) {
            commit(SET_ACTIVITY_LOG, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_ACTIVITY_LOG, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_ACTIVITY_LOG, { isLoading: false });
          return false;
        }
      } catch (error) {
        commit(SET_ACTIVITY_LOG, { isLoading: false });
        commit(SET_ERRORMSG, "Failed to edit activity log. Please try again.");
        return false;
      }
    },
    [DELETE_ACTIVITY_LOG]: async ({ commit }: any, payload: string) => {
      commit(SET_ACTIVITY_LOG, { data: { id: payload }, isLoading: true });

      try {
        const result: AxiosResponse = await ActivityLog.deleteActivityLog(payload);

        if (result) {
          if (result.data.status) {
            commit(SET_ACTIVITY_LOG, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_ACTIVITY_LOG, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_ACTIVITY_LOG, { isLoading: false });
          return false;
        }
      } catch (error) {
        commit(SET_ACTIVITY_LOG, { isLoading: false });
        commit(SET_ERRORMSG, "Failed to delete activity log. Please try again.");
        return false;
      }
    },
    [CLEAR_ACTIVITY_LOG_ISLOADING]: ({ commit }) => {
      commit(SET_ACTIVITY_LOG, { isLoading: false });
      commit(SET_ACTIVITY_LOGS, { isLoading: false });
    },
  },
};

export default activityLog;
